import type { ConsentChoice } from "@/consent/consent";

export const CONSENT_BANNER = {
  regionLabel: "Cookie preferences",
  title: "We value your privacy.",
  body: "We use cookies for site functionality, analytics, and advertising.",
  acceptAll: "Accept All",
  settings: "Cookie Settings",
  dismiss: "Dismiss and keep current cookie settings",
  announcement:
    "We use cookies. Cookie preference choices are available at the end of the page.",
};

export type ConsentTier = {
  id: string;
  headline: string;
  description: string;
  choice: ConsentChoice;
};

export const CONSENT_SETTINGS = {
  title: "Choose your settings",
  save: "Save Settings",
  close: "Close cookie settings",
  privacyNoticeLabel: "Privacy Policy",
  privacyNoticeHref: "/privacy-policy",
  // Radios, most private first: picking a row enables everything above it.
  tiers: [
    {
      id: "necessary",
      headline: "Necessary and functional cookies",
      description:
        "These cookies are required for our site to work properly by supporting core functions like security, checkout, and remembering your preferences. Because they’re necessary for site function, these can’t be turned off.",
      choice: { analytics: false, marketing: false },
    },
    {
      id: "analytics",
      headline: "Analytics cookies",
      description:
        "These cookies allow us to analyze and measure site usage, testing, and performance.",
      choice: { analytics: true, marketing: false },
    },
    {
      id: "advertising",
      headline: "Advertising cookies",
      description:
        "These cookies may be used by us or our advertising partners to measure ads and show you ads that may be relevant to you.",
      choice: { analytics: true, marketing: true },
    },
  ] satisfies ConsentTier[],
};

// The privacy-choices page copy names this link; keep them in sync.
export const FOOTER_COOKIE_PREFERENCES_LABEL = "Cookie Settings";
